module.exports = __webpack_public_path__ + "img/shipo-icon-calendar-eta-black.371764ae.svg";